/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const styles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const Section = ({ children }) => <section css={styles}>{children}</section>;

export default Section;
